import { useEffect } from 'react'
import { ui } from '../styles/ui'

const TOAST_STYLE = {
  info: ui.states.loading,
  warning: ui.states.warning,
  error: ui.states.error,
}

export default function Toast({
  alert,
  index = 0,
  onDismiss,
  onAcknowledge,
  timeoutMs = 4000,
}) {
  useEffect(() => {
    if (!alert || alert.persistent) return undefined
    const timer = setTimeout(() => {
      onDismiss?.(alert.id)
    }, timeoutMs)
    return () => clearTimeout(timer)
  }, [alert, onDismiss, timeoutMs])

  if (!alert) return null

  const style = TOAST_STYLE[alert.severity] || TOAST_STYLE.info
  return (
    <div
      role="status"
      className={`fixed right-4 z-50 w-[340px] ${style} shadow-sm`}
      style={{ top: `${1 + (index * 4.5)}rem` }}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wide">{alert.type || 'Alert'}</p>
          <p className="mt-1 text-sm break-words">{alert.message}</p>
        </div>
        <div className="flex items-center gap-1">
          {onAcknowledge && (
            <button
              type="button"
              className={ui.buttons.smGhost}
              onClick={() => onAcknowledge(alert.id)}
            >
              Ack
            </button>
          )}
          <button
            type="button"
            className={ui.buttons.smGhost}
            onClick={() => onDismiss?.(alert.id)}
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  )
}
